
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/brew-guides",
      function () {
        return require("private-next-pages/[region]/[lang]/brew-guides/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/brew-guides"])
      });
    }
  